import * as React from 'react';
const CarenzaDiFerroIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M98.19 80.52 86.56 59.69l-23.68 42.44a25.2 25.2 0 0 0-3.19 12.26c0 14.31 12.02 25.91 26.87 25.91 6.49 0 12.44-2.22 17.08-5.92"
      className="prefix__cls-2"
    />
    <path
      d="m70.23 106.21 4.5-8.07M85.31 131.87c-8.76-.56-15.86-6.94-17.04-15.08"
      className="prefix__cls-1"
    />
    <path
      d="M133.59 106.72c0-12.06-9.77-21.84-21.83-21.84s-21.83 9.78-21.83 21.84 9.77 21.83 21.83 21.83 21.83-9.77 21.83-21.83M140.3 135.27l-13.11-13.12"
      className="prefix__cls-2"
    />
    <path
      d="M123.55 104.85c-2.9-2.64-8.66-1.69-12.85 2.13-4.2 3.81-5.24 9.04-2.34 11.68s8.66 1.69 12.85-2.13c4.2-3.81 5.24-9.04 2.34-11.68"
      className="prefix__cls-1"
    />
    <path
      d="M120.16 108.58c.15.4-.26 2.34-2.33 4.22-1.87 1.7-3.88 2.31-5.13 2.31h0M113.38 105.04c.02-.12.03-.22.03-.33.29-5.56-2.86-9.93-7.02-9.74s-7.78 4.84-8.06 10.41c-.29 5.56 2.86 9.93 7.02 9.74.47-.02.92-.1 1.38-.23"
      className="prefix__cls-1"
    />
    <path
      d="M106.62 100c-1.05.05-3.08 2.22-3.25 5.64-.01.28-.02.55 0 .8"
      className="prefix__cls-1"
    />
  </svg>
);
export default CarenzaDiFerroIcon;
